import "../../styles/Benefits/IncomePlan.less"
import "../ExplainerGIFT/ExplainerGIFT.less"
import DOMPurify from "dompurify"
import Image from "./Image"

const CheckList = ({ data, className, itemClass, textClassName, imageClassName, imgSrc, ...props }) => {
  return (
    <div className={className}>
      {data.map((value, index) => (
        <div key={index} className={itemClass} style={{ display: "flex", alignItems: "center" }}>
          <Image defer={false} className={imageClassName} src={imgSrc} alt={""} />
          <div className={textClassName} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(value.text) }} />
        </div>
      ))}
    </div>
  )
}

export default CheckList
